import React, { useState } from 'react';
import CustomerDetailModal from './CustomerDetailModal';

export default function CustomerManager({ customers, items, onAdd, onEdit, onDelete, autoOpenAdd }) {
  const [showAdd, setShowAdd] = useState(autoOpenAdd || false);
  const [showEdit, setShowEdit] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [form, setForm] = useState({ name: '', contactInfo: '' });
  const [error, setError] = useState('');

  // Helper: Can delete only if all items for this customer have qty 0
  function canDeleteCustomer(customerId) {
    return items.filter(i => i.clientId === customerId && Number(i.currentQty) > 0).length === 0;
  }

  function handleAdd() {
    if (!form.name.trim()) {
      setError('Customer name required');
      return;
    }
    onAdd(form);
    setForm({ name: '', contactInfo: '' });
    setShowAdd(false);
    setError('');
  }

  function handleEdit() {
    if (!form.name.trim()) {
      setError('Customer name required');
      return;
    }
    onEdit({ ...selectedCustomer, ...form });
    setShowEdit(false);
    setSelectedCustomer(null);
    setError('');
  }

  function openEdit(cust) {
    setSelectedCustomer(cust);
    setForm({ name: cust.name, contactInfo: cust.contactInfo || '' });
    setShowEdit(true);
    setError('');
  }

  function handleDelete(cust) {
    if (!canDeleteCustomer(cust.id)) {
      setError('Cannot delete: This customer still has items with nonzero quantity.');
      return;
    }
    if (!window.confirm('Are you sure you want to delete this customer?')) return;
    onDelete(cust);
    setError('');
  }

  return (
    <div style={{maxWidth:500,margin:'0 auto',background:'#fff',borderRadius:16,boxShadow:'0 2px 12px #1976d222',padding:32}}>
      <h3 style={{marginTop:0,marginBottom:14,color:'#1976d2',fontWeight:700,fontSize:'1.25rem'}}>Customer Manager</h3>
      <button onClick={()=>setShowAdd(true)} style={{marginBottom:14,background:'#1976d2',color:'#fff',padding:'8px 24px',border:'none',borderRadius:8,fontWeight:700}}>Add Customer</button>
      {error && <div style={{color:'red',marginBottom:10}}>{error}</div>}
      <table style={{width:'100%',marginBottom:18}}>
        <thead>
          <tr><th>Name</th><th>Contact Info</th><th>Actions</th></tr>
        </thead>
        <tbody>
          {customers.map(cust => (
            <tr key={cust.id}>
              <td>
                <span
                  style={{cursor:'pointer',color:'#1976d2',fontWeight:600,display:'inline-block',padding:'2px 0'}}
                  onClick={()=>{setSelectedCustomer(cust);}}
                  tabIndex={0}
                  title="View all items/descriptions for this customer"
                >{cust.name}</span>
              </td>
              <td>{cust.contactInfo || ''}</td>
              <td>
                <button onClick={()=>openEdit(cust)} style={{marginRight:8}}>Edit</button>
                <button
                  onClick={()=>handleDelete(cust)}
                  disabled={!canDeleteCustomer(cust.id)}
                  style={{opacity: canDeleteCustomer(cust.id) ? 1 : 0.5, cursor: canDeleteCustomer(cust.id) ? 'pointer' : 'not-allowed'}}
                  title={!canDeleteCustomer(cust.id) ? 'Cannot delete: Customer has items with quantity > 0' : 'Delete this customer'}
                >Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {/* Add Modal */}
      {showAdd && (
        <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'#0008',zIndex:30,display:'flex',alignItems:'center',justifyContent:'center'}}>
          <form onSubmit={e=>{e.preventDefault();handleAdd();}} style={{background:'#fff',padding:32,borderRadius:16,minWidth:320,boxShadow:'0 8px 32px 0 rgba(60,60,100,0.18)',display:'flex',flexDirection:'column',gap:14}}>
            <h4 style={{margin:0}}>Add Customer</h4>
            <input value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} placeholder="Name" required style={{padding:10,borderRadius:6,border:'1px solid #bdbdbd'}} />
            <input value={form.contactInfo} onChange={e=>setForm(f=>({...f,contactInfo:e.target.value}))} placeholder="Contact Info" style={{padding:10,borderRadius:6,border:'1px solid #bdbdbd'}} />
            <div style={{display:'flex',gap:12,justifyContent:'flex-end'}}>
              <button type="button" onClick={()=>setShowAdd(false)} style={{background:'#fff',color:'#1976d2',border:'1.5px solid #1976d2',padding:'8px 18px',borderRadius:7}}>Cancel</button>
              <button type="submit" style={{background:'#1976d2',color:'#fff',padding:'8px 18px',border:'none',borderRadius:7}}>Add</button>
            </div>
          </form>
        </div>
      )}
      {/* Edit Modal */}
      {showEdit && (
        <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'#0008',zIndex:30,display:'flex',alignItems:'center',justifyContent:'center'}}>
          <form onSubmit={e=>{e.preventDefault();handleEdit();}} style={{background:'#fff',padding:32,borderRadius:16,minWidth:320,boxShadow:'0 8px 32px 0 rgba(60,60,100,0.18)',display:'flex',flexDirection:'column',gap:14}}>
            <h4 style={{margin:0}}>Edit Customer</h4>
            <input value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} placeholder="Name" required style={{padding:10,borderRadius:6,border:'1px solid #bdbdbd'}} />
            <input value={form.contactInfo} onChange={e=>setForm(f=>({...f,contactInfo:e.target.value}))} placeholder="Contact Info" style={{padding:10,borderRadius:6,border:'1px solid #bdbdbd'}} />
            <div style={{display:'flex',gap:12,justifyContent:'flex-end'}}>
              <button type="button" onClick={()=>setShowEdit(false)} style={{background:'#fff',color:'#1976d2',border:'1.5px solid #1976d2',padding:'8px 18px',borderRadius:7}}>Cancel</button>
              <button type="submit" style={{background:'#1976d2',color:'#fff',padding:'8px 18px',border:'none',borderRadius:7}}>Save</button>
            </div>
          </form>
        </div>
      )}
      {/* Customer Detail Modal */}
      {selectedCustomer && (
        <CustomerDetailModal
          open={!!selectedCustomer}
          customer={selectedCustomer}
          items={items}
          onClose={()=>setSelectedCustomer(null)}
        />
      )}
    </div>
  );
}
